import {styled} from '@vw-marketing/us-components';

export const ReviewDataWrapper: any = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 10px;
  color: #758189;
`;

export const ReplyCommentWrapper: any = styled.div`
  border-top: 1px solid #dfe4e8;
  padding-top: 30px;
  margin-top: 30px;
`;
export const ReviewCommentWrapper: any = styled.div`
  height: auto;
  padding-top: 30px;
  overflow: hidden;
`;

export const ReviewerNameWrapper: any = styled.div``;

export const ReviewerApplyNameWrapper: any = styled.div`
  display: flex;
  align-items: center;
  color: #758189;
  justify-content: space-between;
`;
export const ViewMoreButtonWrapper: any = styled.div``;

interface StyledOpacityWrapperProps {
  isOpacity?: boolean;
}
export const StyledOpacityWrapper: any = styled.div<StyledOpacityWrapperProps>`
  ${(props: StyledOpacityWrapperProps) =>
    props.isOpacity &&
    ` position: absolute;
    width: calc(100% + 2px);
    height: 100%;
    top: -1px;
    right: -1px;
    background-color: white;
    opacity: 0.48;
    z-index: 1;
  `}
`;

interface ReviewCardContainerProps {
  containerHeight: boolean;
}
export const ReviewCardContainer: any = styled.div<ReviewCardContainerProps>`
  border: 1px solid #dfe4e8;
  padding: 30px;
  margin-bottom: 30px;
  padding-bottom: 33px;
  display: flex;
  flex-flow: column;
  height: auto;
`;

export const StyledDealerCommentType: any = styled.div`
  width: 100%;
  display: flex;
  padding-bottom: 20px;
  .comment-type-wrapper {
    background-color: #C2CACF;
    color: #3C484D;
    padding: 10px 20px;
    border-radius: 4px;
    div {
      margin: 0;
    }
  }
`

